import {
  FileText,
  Mail,
  MessageSquare,
  Mic,
  Paperclip,
  StickyNote,
} from 'lucide-react';
import React from 'react';

import { RainmakerEvidenceType } from '@/services/types/rainmaker-types';

export const getEvidenceIcon = (type: RainmakerEvidenceType) => {
  switch (type) {
    case RainmakerEvidenceType.FRONT_MESSAGE:
    case RainmakerEvidenceType.FRONT_CONVERSATION:
    case RainmakerEvidenceType.EMAIL:
      return <Mail className="h-4 w-4" />;
    case RainmakerEvidenceType.DOCUMENT:
      return <FileText className="h-4 w-4" />;
    case RainmakerEvidenceType.BLOB:
    case RainmakerEvidenceType.EMAIL_ATTACHMENT:
    case RainmakerEvidenceType.MESSAGE_ATTACHMENT:
      return <Paperclip className="h-4 w-4" />;
    case RainmakerEvidenceType.TRANSCRIPT:
    case RainmakerEvidenceType.AUDIO_CONVERSATION:
      return <Mic className="h-4 w-4" />;
    case RainmakerEvidenceType.MESSAGE:
    case RainmakerEvidenceType.CONVERSATION:
      return <MessageSquare className="h-4 w-4" />;
    case RainmakerEvidenceType.INTAKE_NOTE:
    case RainmakerEvidenceType.STAFF_NOTE:
      return <StickyNote className="h-4 w-4" />;
    default:
      return <FileText className="h-4 w-4" />;
  }
};
